import React, {Dispatch, FC, SetStateAction} from 'react';
import {UploadFile} from "antd/es/upload";
import {defineMessages, useIntl} from "react-intl";
import {CustomModal} from "../../../../components/UI/AntCustom/CustomModal";


const PlaneLicensesModalMessages = defineMessages({
  title: {
    id: "planeLicensesModal.title",
    defaultMessage: "Licenses and files"
  },
  warn: {
    id: "planeLicensesModal.warn",
    defaultMessage: "No files uploaded yet."
  },
  operatorCertificate: {
    id: "planeLicensesModal.operatorCertificate",
    defaultMessage: "AOC"
  },
  registrationCertificate: {
    id: "planeLicensesModal.registrationCertificate",
    defaultMessage: "Certificate of incorporation"
  },
  caaOperatorApproval: {
    id: "planeLicensesModal.caaOperatorApproval",
    defaultMessage: "CAA operator approval to operate international flights"
  },
  easaTcoAuthorisation: {
    id: "planeLicensesModal.easaTcoAuthorisation",
    defaultMessage: "EU: EASA TCO authorisation"
  },
  faaAuthorization: {
    id: "planeLicensesModal.faaAuthorization",
    defaultMessage: "US: FAA authorization"
  },
})

interface PlaneLicensesModalProps {
  isVisible: boolean;
  setIsVisible: Dispatch<SetStateAction<boolean>>;
  insuranceFile?: UploadFile;
  certificateFile?: UploadFile;
  etopsFile?: UploadFile;
  // International Flights documents
  operatorCard?: UploadFile; // AOC
  registrationCertificate?: UploadFile; // Certificate of incorporation
  caaOperatorApproval?: UploadFile;
  easaTcoAuthorisation?: UploadFile;
  faaAuthorization?: UploadFile;
}

export const PlaneLicensesModal: FC<PlaneLicensesModalProps> = ({
  isVisible,
  setIsVisible,
  insuranceFile,
  certificateFile,
  etopsFile,
  operatorCard,
  registrationCertificate,
  caaOperatorApproval,
  easaTcoAuthorisation,
  faaAuthorization
}) => {
  const intl = useIntl();

  const hasAnyFile = insuranceFile || certificateFile || etopsFile || 
                     operatorCard || registrationCertificate || 
                     caaOperatorApproval || easaTcoAuthorisation || faaAuthorization;

  return (
    <CustomModal
      title={intl.formatMessage(PlaneLicensesModalMessages.title)}
      open={isVisible}
      onCancel={() => setIsVisible(false)}
      centered
      footer={null}
    >
      {!hasAnyFile && intl.formatMessage(PlaneLicensesModalMessages.warn)}
      <ul>
        {operatorCard &&
          <li key={operatorCard.uid}>
            <a href={operatorCard.url} target={'_blank'} rel="noreferrer">
              {intl.formatMessage(PlaneLicensesModalMessages.operatorCertificate)}: {operatorCard.name}
            </a>
          </li>}

        {registrationCertificate &&
          <li key={registrationCertificate.uid}>
            <a href={registrationCertificate.url} target={'_blank'} rel="noreferrer">
              {intl.formatMessage(PlaneLicensesModalMessages.registrationCertificate)}: {registrationCertificate.name}
            </a>
          </li>}

        {insuranceFile &&
          <li key={insuranceFile.uid}>
            <a href={insuranceFile.url} target={'_blank'} rel="noreferrer">
              {insuranceFile.name}
            </a>
          </li>}

        {certificateFile &&
          <li key={certificateFile.uid}>
            <a href={certificateFile.url} target={'_blank'} rel="noreferrer">
              {certificateFile.name}
            </a>
          </li>}

        {etopsFile &&
          <li key={etopsFile.uid}>
            <a href={etopsFile.url} target={'_blank'} rel="noreferrer">
              {etopsFile.name}
            </a>
          </li>}

        {caaOperatorApproval &&
          <li key={caaOperatorApproval.uid}>
            <a href={caaOperatorApproval.url} target={'_blank'} rel="noreferrer">
              {intl.formatMessage(PlaneLicensesModalMessages.caaOperatorApproval)}: {caaOperatorApproval.name}
            </a>
          </li>}

        {easaTcoAuthorisation &&
          <li key={easaTcoAuthorisation.uid}>
            <a href={easaTcoAuthorisation.url} target={'_blank'} rel="noreferrer">
              {intl.formatMessage(PlaneLicensesModalMessages.easaTcoAuthorisation)}: {easaTcoAuthorisation.name}
            </a>
          </li>}

        {faaAuthorization &&
          <li key={faaAuthorization.uid}>
            <a href={faaAuthorization.url} target={'_blank'} rel="noreferrer">
              {intl.formatMessage(PlaneLicensesModalMessages.faaAuthorization)}: {faaAuthorization.name}
            </a>
          </li>}
      </ul>
    </CustomModal>
  );
};

